(function ($) {
  $(document).ready(function() {
    $('.flexslider-image-products').flexslider({
      namespace: "flex-",
      animation: "fade",
      itemWidth: 170,
      slideshowSpeed: 3000,
      animationSpeed: 800,
      selector: ".slides-wrapper .field--type-ds",
      controlNav: false,
      directionNav: false,
    });
  });
})(jQuery);
